import { Theme } from "@mui/material";

export const getStyles = (theme: Theme) => ({
  padding: "0px",
  "& .MuiListItem-root": {
    padding: "10px 175px 13px 20px",
    border: "1px solid #DFE0E3",
    borderRadius: "8px",
    "&:not(:last-child)": {
      marginBottom: "13px"
    },
    "& .MuiListItemIcon-root": {
      minWidth: "16px"
    },
    "& .MuiListItemSecondaryAction-root": {
      width: "165px",
      "& .MuiBadge-root": {
        marginRight: "2px",
        "& .MuiBadge-badge": {
          width: "14px",
          height: "14px",
          padding: "0px",
          minWidth: "0px",
          boxSizing: "border-box",
          border: `2px solid ${theme.palette.common.white}`,
        }
      }
    },
  }
});